// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6e824726] .el-dialog__body{padding:30px 20px;color:#606266;font-size:14px;word-break:break-all;overflow:auto}[data-v-6e824726] .list-box-f{margin-bottom:20px;height:30px}[data-v-6e824726] .el-dialog__header{background:#f7f8f9;border-bottom:1px solid #e9ebee;padding:14px 20px 13px 20px;border-radius:5px 5px 0 0}", ""]);
// Exports
module.exports = exports;
